import { render, staticRenderFns } from "./MmStatusBadge.vue?vue&type=template&id=69060af9&scoped=true"
import script from "./MmStatusBadge.vue?vue&type=script&lang=ts"
export * from "./MmStatusBadge.vue?vue&type=script&lang=ts"
import style0 from "./MmStatusBadge.vue?vue&type=style&index=0&id=69060af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69060af9",
  null
  
)

export default component.exports